import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [categories, setCategories] = useState([]);
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "ta");

  useEffect(() => {
    api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/public/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const tag = lang === "ta" ? settings.tagline_ta || settings.tagline : settings.tagline;
    if (settings.site_name) document.title = `${settings.site_name} – ${tag || ""}`;
  }, [settings.site_name, settings.tagline, settings.tagline_ta, lang]);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("lang", l);
    setLangState(l);
  };

  return (
    <SiteCtx.Provider value={{ settings, setSettings, categories, setCategories, lang, setLang }}>
      {children}
    </SiteCtx.Provider>
  );
}

export const useSite = () => useContext(SiteCtx);
